import React from 'react';

import PhoneInput, { Country } from 'react-phone-number-input';
// Not possible to import dynamically because the packages cannot be resolved correctly. Thus we catch non-imported locales in the default case below
import deLabels from 'react-phone-number-input/locale/de.json';
import enLabels from 'react-phone-number-input/locale/en.json';
import frLabels from 'react-phone-number-input/locale/fr.json';
import { useSelector } from 'react-redux';

import { getSelectedLanguageSelector } from 'components/App/LanguageProvider/store/selectors';
import ControlWrapper from 'components/ControlWrapper';
import withFormField from 'utils/form/withFormField';

import { InputWrapper } from './styles';
import InputContainer from '../Input/InputWrapper/InputContainer';

const PhoneNumberInput = (props: any) => {
  const { onChange, input, onBlur, testId, fieldName, ...rest } = props;
  const lang = useSelector(getSelectedLanguageSelector);
  let locale;
  let labels = deLabels;
  switch (lang) {
    case 'de':
      labels = deLabels;
      locale = 'DE';
      break;
    case 'en':
      labels = enLabels;
      locale = 'GB';
      break;
    case 'fr':
      labels = frLabels;
      locale = 'FR';
      break;
    default:
      throw new Error(
        'Unsupported locale in the PhoneNumberInput component. Please add the labels for the current locale to the component.',
      );
  }

  return (
    <ControlWrapper {...rest}>
      <InputContainer>
        <InputWrapper>
          <PhoneInput
            labels={labels}
            international
            withCountryCallingCode
            defaultCountry={locale as Country}
            onChange={onChange}
            onBlur={onBlur}
            value={input.value}
            data-testid={fieldName}
            name={fieldName}
          />
        </InputWrapper>
      </InputContainer>
    </ControlWrapper>
  );
};

export const PhoneNumberField = withFormField(PhoneNumberInput, { showErrorsWhenPristine: false });
export const PhoneNumberFieldWithOnMountError = withFormField(PhoneNumberInput, {
  showErrorsWhenPristine: true,
});
